import type { AnyFieldApi } from '@tanstack/react-form';
import { TextBox, type TextBoxProps } from '@/shared/ui';

export interface TextFieldProps extends Omit<
  TextBoxProps,
  'value' | 'onChange' | 'onBlur' | 'error'
> {
  /** TanStack Form field API (z render-prop `form.Field`). */
  field: AnyFieldApi;
}

/**
 * Adapter mezi TanStack Form polem a Phoenix `TextBox`.
 * Chybu zobrazuje až po dotčení pole (`isTouched`) – po submitu jsou pole označena automaticky.
 */
export function TextField({ field, ...props }: TextFieldProps) {
  const error = field.state.meta.isTouched
    ? (field.state.meta.errors[0]?.message as string | undefined)
    : undefined;

  return (
    <TextBox
      value={(field.state.value as string | undefined) ?? ''}
      onChange={(event) => field.handleChange(event.target.value)}
      onBlur={field.handleBlur}
      error={error}
      {...props}
    />
  );
}
